<template>
  <div class="month-area">
    <button type="button" class="btn-prev" @click="$emit('prev')" v-if="attainment.month > 3"><span class="blind">이전</span></button>
    <span class="month-value">{{attainment.year}}.{{attainment.month}}</span>
    <button type="button" class="btn-next" @click="$emit('next')" v-if="attainment.month < 5"><span class="blind">다음</span></button>
  </div>
</template>
<script>
export default {
  props: ['attainment']
}
</script>

<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard/component/calendar.vue